<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">{{ titulo }}</span>
                    </b-card-header>
                    <b-card-body>
                        <slot name="controles"></slot>
                        <app-tabela
                            idTabela="tblEntregas"
                            :itens="entregas"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="descritivo" slot-scope="data">
                                <app-status
                                    v-if="data.manual"
                                    status="ENTREGA MANUAL"
                                ></app-status>
                                {{ data.descritivo }}
                            </template>
                            <template slot="natureza" slot-scope="data">
                                <app-status
                                    :status="data.natureza"
                                ></app-status>
                            </template>
                            <template slot="contratacao" slot-scope="data">
                                <app-contratacao-detalhar
                                    :contratacao="data.contratacao"
                                ></app-contratacao-detalhar>
                            </template>
                            <template slot="temAnexos" slot-scope="data">
                                <app-status
                                    :status="data.temAnexos ? 'SIM' : 'NÃO'"
                                ></app-status>
                            </template>
                            <template slot="valorHora" slot-scope="data">
                                <p class="text-right m-0 p-0">
                                    {{ data.valorHora | currency }}
                                </p>
                            </template>
                            <template slot="valorTotal" slot-scope="data">
                                <p class="text-right m-0 p-0">
                                    {{ data.valorTotalPrevisto | currency }}
                                </p>
                            </template>
                            <template
                                slot="valorTotalEntregue"
                                slot-scope="data"
                            >
                                <p class="text-right m-0 p-0">
                                    {{ data.valorTotalEntregue | currency }}
                                </p>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <slot name="entregaAcoes" v-bind="data"></slot>
                            </template>
                            <template
                                slot="entregaSelecao"
                                slot-scope="data"
                                v-if="incluirSelecao"
                            >
                                <slot
                                    name="entregaSelecao"
                                    v-bind="data"
                                ></slot>
                            </template>
                            <template slot="statusIdRm" slot-scope="data">
                                <entrega-comprometimento
                                    :entrega="data"
                                    :movimentosServicos="movimentosServicos"
                                    @obterAtualizacao="
                                        $emit('obterAtualizacao')
                                    "
                                ></entrega-comprometimento>
                            </template>
                            <template slot="statusDescr" slot-scope="data">
                                <app-status
                                    :status="data.statusDescr"
                                ></app-status>
                                <span
                                    class="text-info ml-2"
                                    v-if="data.gestorSubstituto"
                                >
                                    <i
                                        class="fa fa-user fa-lg icon-button"
                                        :title="data.gestorSubstituto"
                                    ></i>
                                </span>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratacaoDetalhar from './../contratacoes/ContratacaoDetalhar2'
import EntregaComprometimento from './EntregaComprometimento'

export default {
    props: {
        entregas: {
            type: Array,
            default: () => []
        },

        incluirSelecao: {
            type: Boolean,
            default: false
        },

        titulo: {
            type: String,
            default: 'Entregas'
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'contratacao',
                    label: 'Contratação',
                    filterable: true
                },
                {
                    key: 'contratacao.credenciado',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Natureza',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorHora',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'dataPrevisao',
                    label: 'Previsão de Entrega',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'cargaHorariaPrevista',
                    label: 'CH Prev.',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Total Previsto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'dataEntrega',
                    label: 'Entrega',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'cargaHorariaEntregue',
                    label: 'CH Entr.',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotalEntregue',
                    label: 'Total Entregue',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'temAnexos',
                    label: 'Anexos',
                    tdClass: 'text-center'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'statusIdRm',
                    label: 'Comprometimento'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {},

    computed: {},

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'entregaSelecao',
                label: ''
            })
        }
    },

    components: {
        AppContratacaoDetalhar: ContratacaoDetalhar,
        EntregaComprometimento: EntregaComprometimento
    }
}
</script>
